export const SwivuSchedulerMenuPluginMixin = (target) =>
  class SwivuSchedulerMenuMixin extends target {
    static get $name() {
      return "SwivuSchedulerMenuPluginMixin";
    }

    static itemsKeyRef = {
      pasteEvent: "swivuPasteEvent",
      newTask: "swivuNewTask",
      findTask: "swivuFindTask",
      insertTask: "swivuInsertTask",
      replaceTask: "swivuReplaceTask",
      addReminderOnEvent: "swivuAddReminderOnEvent",
      taskFiles: "swivuTaskFiles",
    }

    itemsKeys = {
      pasteEvent: {
        icon: "fa fa-paste",
        text: "Paste Event",
      },
      newTask: {
        text: "New Task",
        icon: "fa fa-plus",
      },
      findTask: {
        icon: "fa fa-search",
        text: "Find Task"
      },
      addReminder: {
        text: "Remind...",
        icon: "fa fa-bell",
      },
      taskFiles: {
        text: "Task Files",
        icon: "fa-solid fa-file",
      }
    }

    getScheduleTaskMenuItem(eventRecord = null, menutItemConfigs = {}) {
      return {
        ...menutItemConfigs,
        text: eventRecord ? "Replace" : "Insert",
        icon: eventRecord ? "fa-solid fa-arrows-rotate" : "fa-solid fa-pen",
        menu: {
          items : {
            [SwivuSchedulerMenuMixin.itemsKeyRef.newTask]: this.itemsKeys.newTask,
            [SwivuSchedulerMenuMixin.itemsKeyRef.findTask]: this.itemsKeys.findTask
          }
        },
      }
    }

    // this is specifically for event menu showing from event right click
    getPasteMenuItem({ eventRecord }, menuItemConfigs = {}) {
      const schedule = this.client;
      const onPasteItemClick = ({ resourceRecord, date }) => {
        eventRecord.remove();
        schedule.features.eventCopyPaste.pasteEvents(date, resourceRecord);
      }

      return {
        ...this.itemsKeys.pasteEvent,
        ...menuItemConfigs,
        onItem: onPasteItemClick,
      }
    }

    getNewTaskMenuItem(event, menuItemConfigs = {}) {
      return {
        ...this.itemsKeys.newTask,
        ...menuItemConfigs,
      }
    }

    getAddReminderMenuItem(event, menuItemConfigs = {}) {
      return {
        ...this.itemsKeys.addReminder,
        ...menuItemConfigs,
      }
    }

    getTaskFilesMenuItem(_event, menuItemConfigs = {}) {
      return {
        ...this.itemsKeys.taskFiles,
        ...menuItemConfigs,
      }
    }
  }
